import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { Header } from "@/components/Header";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Marketplace from "@/pages/Marketplace";
import JobDetail from "@/pages/JobDetail";
import Dashboard from "@/pages/Dashboard";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";
import Billing from "@/pages/Billing";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import MyProfile from "@/pages/MyProfile";
import { BottomNav } from "@/components/BottomNav";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="py-32 text-center text-zinc-400">...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/jobs" element={<Marketplace />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/profile/:id" element={<Profile />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/messages" element={<Protected><Messages /></Protected>} />
            <Route path="/billing" element={<Protected><Billing /></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/profiel" element={<Protected><MyProfile /></Protected>} />
          </Routes>
          <BottomNav />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
